<div class="files-wrapper qo-flex-col-top-center qo-position-relative">
	<qo-loader
		*ngIf="showLoader"
	></qo-loader>
	<qo-list-view
		*ngIf="currentFileEntries.length !== 0"
		[dataSource]="currentFileEntries"
		[lastColumnRightPositioned]="true"
		class="qo-max-width qo-margin-bottom30"
	>
		<qo-list-view-column>
			<ng-template let-item>
				<div class="qo-flex-row-center-left">
					<div
						*ngIf="withFileSelection"
						class="qo-margin-right20"
					>
						<qo-checkbox
							[value]="isFileSelected(item)"
							(valueChange)="isFileSelected(item) ? deselectFile(item): selectFile(item)"
							[backgroundColor]="COLOR.GOLDEN_BROWN"
						></qo-checkbox>
					</div>
					<div class="file-icon-holder">
						<i [class]="'fileIcon fas '+ item.fileIconClass()">
						</i>
					</div>
					<div class="qo-flex-col-center-left">
						<label class="title">{{item.original_file_name}}</label>
						<label class="extension">{{item.extension}}</label>
					</div>
				</div>
			</ng-template>
		</qo-list-view-column>
		<qo-list-view-column>
			<ng-template let-item>
				<div class="qo-flex-row-center-right">
					<div class="qo-margin-left15">
						<qo-icon
							[icon]="EQORebrandIcon.download_dark"
							[invertedScheme]="true"
							[scheme]="EQORebrandColor.SECONDARY"
							[color]="EQORebrandColor.SECONDARY"
							[size]="'sm'"
							(click)="downloadFile(item)"
						></qo-icon>
					</div>
					<div class="qo-margin-left15">
						<qo-icon
							*ngIf="edit"
							[icon]="EQORebrandIcon.trash_dark"
							[invertedScheme]="true"
							[scheme]="EQORebrandColor.SECONDARY"
							[color]="EQORebrandColor.SECONDARY"
							[size]="'sm'"
							(click)="removeFileEntry(item)"
						></qo-icon>
					</div>
				</div>
			</ng-template>
		</qo-list-view-column>
	</qo-list-view>

	<qo-empty-state
		class="qo-margin-bottom30"
		*ngIf="currentFileEntries.length === 0"
		[icon]="ICON.EMPTY_STATE_CLEAN"
		[title]="'FILE_ENTRY_MANAGER.NOT_ANY_FILES_YET' | translate"
	></qo-empty-state>

	<div class="qo-flex-row-center-center" *ngIf="currentUser.permission_level === 2 && edit">
		<input #fileInput type="file"
					 class="fileInput"
					 id="file"
					 [ngStyle]="{display: 'none'}"
					 (change)="filesAdded($event)" multiple
					 [accept]="ACCEPT">

		<button class="qo-button-standard qo-secondary-invert" (click)="withFileSelector ? fileInput.click(): openMediaLibrary()">
			<qo-icon [icon]="EQORebrandIcon.upload_dark" [size]="'sm'" [color]="EQORebrandColor.SECONDARY"></qo-icon>
			{{'FILE_ENTRY.UPLOAD' | translate}}
		</button>
	</div>

</div>
